module.exports = __webpack_public_path__ + "img/ic-chart-trend.c5e07d39.svg";